const DEFAULT_MINOR_UNIT_DIGITS = 2;

export function resolveCurrencyMinorUnitDigits(currency: string, language: string): number {
  const formatter = new Intl.NumberFormat(language, {
    style: 'currency',
    currency,
  });
  const resolvedDigits = formatter.resolvedOptions().maximumFractionDigits;
  return resolvedDigits === undefined ? DEFAULT_MINOR_UNIT_DIGITS : resolvedDigits;
}

export function formatPriceFromMinorUnits(
  priceMinorUnits: number | null,
  currency: string,
  language: string
): string | null {
  if (priceMinorUnits === null) {
    return null;
  }
  const formatter = new Intl.NumberFormat(language, {
    style: 'currency',
    currency,
  });
  const majorAmount = priceMinorUnits / Math.pow(10, resolveCurrencyMinorUnitDigits(currency, language));
  return formatter.format(majorAmount);
}

export function convertMajorAmountToMinorUnits(
  majorAmount: number,
  currency: string,
  language: string
): number {
  const minorUnitDigits = resolveCurrencyMinorUnitDigits(currency, language);
  return Math.round(majorAmount * Math.pow(10, minorUnitDigits));
}

export function formatMinorUnitsAsEditableAmount(
  priceMinorUnits: number | null,
  currency: string,
  language: string
): string {
  if (priceMinorUnits === null) {
    return '';
  }
  const minorUnitDigits = resolveCurrencyMinorUnitDigits(currency, language);
  const majorAmount = priceMinorUnits / Math.pow(10, minorUnitDigits);
  return majorAmount.toFixed(minorUnitDigits);
}
